import { Box } from "@mui/material";
import { Admins, Pagination } from "@/organism";
import { AdmDto } from "@/dto/AdmDto";
import useList from "./useList";

export type ListProps = {
  page: number;
  count: number;
  list: AdmDto[];
  isLoading?: boolean;
};

export const List = (props: ListProps) => {
  const { page, count, list, isLoading } = props;
  const {
    admRequest,
    rowsPerPage,
    handleDetail,
    handlePageChange,
    handleRowsPerPageChange,
    handleReset,
    handleSearch,
  } = useList();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Admins.Filter
        onChange={handleSearch}
        onReset={handleReset}
        values={admRequest}
      />
      <Admins.List list={list} onDetail={handleDetail} isLoading={isLoading} />
      {count > 0 && (
        <Pagination
          count={count}
          page={page - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPage={rowsPerPage}
        />
      )}
    </Box>
  );
};
